module.exports = __webpack_public_path__ + "static/img/GAM-Selected.fcabcf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/destinations/GAM-Selected.png
// module id = 276
// module chunks = 0